import { useNavigate } from "react-router-dom";
import contact from "../../../../assets/images/contact.svg";
import { constants } from "../../../../common/constants/constants";
import styles from "./PosTypes.module.scss";
import { PosAcc } from "../../../../types/pos";
import restuarantPOSIcon from "../../../../assets/images/pos/type/restuarant/restuarantPos.svg";
import restuarantPOSHover from "../../../../assets/images/pos/type/restuarant/restuarantPosHover.svg";
import retailPOSIcon from "../../../../assets/images/pos/type/retail/retailPos.svg";
import retailPOSHover from "../../../../assets/images/pos/type/retail/retailPosHover.svg";
import ActionCard from "./ActionCard/ActionCard";

function PosTypes({ posAccount }: { posAccount?: PosAcc }) {
  const restaurantPosState = posAccount?.pos_base_url ? "Success" : "Default";
  const retailPosState = posAccount?.retail_pos_base_url
    ? "Success"
    : "Default";

  const onRestaurantPosClick = () => {
    if (posAccount) {
      navigate(`/admin/pos/${posAccount.id}/types/restaurant/details`);
    } else {
      navigate("/admin/pos/types/restaurant");
    }
  };

  const onRetailPosClick = () => {
    if (posAccount) {
      navigate(`/admin/pos/${posAccount.id}/types/retail/details`);
    } else {
      navigate("/admin/pos/types/retail");
    }
  };

  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.mainHeader}>Connect POS Account</div>
        <div className={styles.section}>
          <div className={styles.posTypeFlex}>
            <div className={styles.card}>
              <ActionCard
                icon={restuarantPOSIcon}
                iconOnHover={restuarantPOSHover}
                actionCardData={{
                  Default: {
                    heading: "Setup Restaurant POS Account",
                    content: "",
                    action: "Connect",
                  },
                  Success: {
                    heading: "Account Connected",
                    content: "Your Restaurant POS Account is connected!",
                  },
                }}
                state={restaurantPosState as "Default" | "Success"}
                onClick={onRestaurantPosClick}
              />
            </div>
            <div className={styles.card}>
              <ActionCard
                icon={retailPOSIcon}
                iconOnHover={retailPOSHover}
                actionCardData={{
                  Default: {
                    heading: "Setup Retail POS Account",
                    content: "",
                    action: "Connect",
                  },
                  Success: {
                    heading: "Account Connected",
                    content: "Your Retail POS Account is connected!",
                  },
                }}
                state={retailPosState as "Default" | "Success"}
                onClick={onRetailPosClick}
              />
            </div>
          </div>
          <div className={styles.contact}>
            <div className={styles.logo}>
              <img className={styles.imgLogo} src={contact} alt="Contact" />
            </div>
            <div className={styles.contactText}>
              <p className={styles.contactText1}>
                {constants.manageCatalogue.help}
              </p>
              <p className={styles.contactText2}>
                {constants.manageCatalogue.email} |
                {constants.manageCatalogue.phoneNo}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PosTypes;
